// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"107":"client-layout","177":"home","204":"admin-layout","239":"blog","456":"switch","535":"login"}[chunkId] + "." + {"107":"3dd5ac8e","177":"a3b80852","204":"c626b068","239":"c2d8c55e","456":"05970790","535":"ba2b94f9"}[chunkId] + ".css";
};